const getVehicleDetails = (pageData, t) => {
  const title = `${pageData.vehicle.year} ${pageData.vehicle.model.name}`;
  const mainTitle = `${pageData.vehicle.year} ${pageData.vehicle.model.name}`;
  const motorcycleRentalSlug = t('routes:motorcycle-rental');

  let locationHeader = '';

  if (pageData.location.address.geo?.name) {
    locationHeader += pageData.location.address.geo.name;
  }
  if (!pageData.location.address.region) {
    if (pageData.location.address.country?.name) {
      locationHeader += `,
    ${pageData.location.address.country.name}`;
    }
  } else if (pageData.location.address.region) {
    if (pageData.location.address.region.code !== null) {
      locationHeader += `, ${pageData.location.address.region.code}`;
    } else if (pageData.location.address.region.name !== null) {
      locationHeader += `, ${pageData.location.address.region.name}`;
    }
  }

  const breadCrumbsProps = (() => {
    const breadCrumb = {
      links: [],
      breadCrumbsTitle: title,
    };

    pageData.location.address.country
      && breadCrumb.links.push({
        text: pageData.location.address.country.name,
        path: `/${motorcycleRentalSlug}/${pageData.location.address.country.slug}`,
      });

    pageData.location.address.region
      && pageData.location.address.region !== null
      && pageData.location.address.region.name !== null
      && pageData.location.address.region.slu !== null
      && breadCrumb.links.push({
        text: pageData.location.address.region.name,
        path: `/${motorcycleRentalSlug}/${pageData.location.address.region.slug}`,
      });
    pageData.location.address.geo
      && breadCrumb.links.push({
        text: pageData.location.address.geo.name,
        path: `/${motorcycleRentalSlug}/${pageData.location.address.geo.slug}`,
      });

    pageData.vehicle.make
      && breadCrumb.links.push({
        text: pageData.vehicle.make.name,
        path: `/${pageData.vehicle.make.slug}/${pageData.location.address.geo.slug}`,
      });

    pageData.vehicle.model
      && breadCrumb.links.push({
        text: pageData.vehicle.model.name,
        path: `/${pageData.vehicle.make.slug}/${pageData.vehicle.model.slug}/${pageData.location.address.geo.slug}`,
      });

    breadCrumb.links = breadCrumb.links.map((link) => ({ ...link, translate: false }));
    return breadCrumb;
  })();

  return {
    title,
    mainTitle,
    breadCrumbsProps,
    locationHeader,
  };
};

export default getVehicleDetails;
